import React from 'react';
import Basepage, { BasePageState } from '../Basepage';

interface ImpressumState extends BasePageState {}
interface ImpressumModel {}

export default class ImpressumPage extends Basepage<
  ImpressumState,
  ImpressumModel
> {
  renderChild(): JSX.Element {
    return (
      <div id="impressum">
        Impressum
        <br />
        <br />
        Gesetzliche Anbieterkennung:
        <br />
        <br />
        <b>Buchbutler</b>
        <br />
        <span style={{ color: '#C0C0C0' }}>
          ist eine Marke der
          <br />
          Moluna GmbH
        </span>
        <br />
        diese vertr. d. d. Geschäftsführer Helge Blischke
        <br />
        Engberdingdamm 27
        <br />
        48268 Greven
        <br />
        Deutschland
        <br />
        Telefon: 02571/8072880
        <br />
        Telefax: 02571/8072881
        <br />
        E-Mail: service@buchbutler.de
        <br />
        <br />
        <br />
        USt-IdNr.: DE296281834
        <br />
        eingetragen im Handelsregister des Amtsgerichtes Steinfurt
        <br />
        Handelsregisternummer HRB 10553
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        Wir sind seit 24.07.2015 Mitglied der Initiative "FairCommerce".
        <br />
        Nähere Informationen hierzu finden Sie unter
        www.haendlerbund.de/faircommerce
        (https://www.haendlerbund.de/de/haendlerbund/interessenvertretung/faircommerce).
        <br />
      </div>
    );
  }
  initState(base: BasePageState): ImpressumState {
    let newState: ImpressumState = {
      ...base,
    };

    return newState;
  }
  getApiReqestUrl(checkOnly: boolean): string {
    return this.state.apiBase + '/Standard.php';
  }

  releaseOneCommand(): void {}
  childDidMount(): void {}
  childDidUnmount(): void {}
  initJSChild(): string {
    return '';
  }
  childDidUpdate(prevProp: any, prevState: any): void {}
  getRightBreadCrumbParts(): JSX.Element {
    return <></>;
  }

  pageHeaderGetter(): string | null {
    return null;
  }
  pageTitleGetter(): string {
    return 'Impressum';
  }
  getBreadCrumb(): JSX.Element {
    return <span>Impressum</span>;
  }
  getType(): string {
    return 'ImpressumPage';
  }
}
